
interface AppConfig {
  title: string
  description: string
  author: string
  siteUrl: string
  thumbnailUrl: string
}

export default {
  title: `SEM Technology`,
  description: `「SEM Technology」は、日本最高峰のマーケティング・テクノロジーを実現することを目指します。`,
  author: `Ryota YAMADA`,
  siteUrl: `https://sem-technology.info`,
  thumbnailUrl: `https://sem-technology.info/assets/images/thumbnail.png`,
} as AppConfig